import * as React from "react";
import {useEffect, useState} from "react";
import { Card, CardContent, Box, Button, Grid } from '@mui/material';
import { Title, List, Datagrid, TextField, RichTextField, TextInput, Edit, SimpleForm, Create, ImageInput, ImageField } from 'react-admin';
import { RichTextInput } from 'ra-input-rich-text';
import Typography from '@mui/material/Typography';
import MessageIcon from '@mui/icons-material/Message';
import ListAltIcon from '@mui/icons-material/ListAlt';
import { PageListTitle, PageEditTitle, PageCreateTitle } from "../components/pageTitles";
import {default as commonStyles} from "../styles/common.js";
import Stack from '@mui/material/Stack';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import CardActions from '@mui/material/CardActions';
import CardMedia from '@mui/material/CardMedia';
import { fetcherGetSync, fetcherSync } from "../utils/fetcher";
import config from "../config";


const styles = {
    subStackDiv: {
        margin: "auto"
    },
    aLink: {
        textDecoration: "none",
        margin: "40px"
    },
    input: {
        width: 600,
        margin: "auto",
        marginTop: "10px",
        marginBottom: "10px"
    }
}


export const ImagesMainPage = () => {

  const [imagesList, setImagesList] = useState([]);

  const loadImagesList = () => {
    let images = fetcherGetSync(config.API_HOST+"/images/");
    return images;
  }

  useEffect(() => {
    setImagesList(loadImagesList());
  }, [])

    return (
    <CardContent>
        <PageListTitle text="Page principale de configuration" />
        <Card sx={{ p: 2 }}>
          <Typography variant="h5" component="h2" style={{textAlign: "center"}}>
            Ajouter une image
          </Typography>

            <Card sx={{ maxWidth: 345, margin: "auto", marginBottom: "30px" }}>
              <CardContent>
                <form 
                  id='uploadForm' 
                  action={config.API_HOST+'/images/'} 
                  method='post' 
                  encType="multipart/form-data">
                    <input type="file" name="sampleFile" />
                    <Button type="submit">Uploader l'image</Button>
                </form>  
              </CardContent>
            </Card>

            <Typography variant="h5" component="h2" style={{textAlign: "center"}}>
              Liste des images
            </Typography>

            <Grid container spacing={2}>
            {
              imagesList.map(image => {
                return (
                  <Grid item xs={4}>
                      <Card sx={{ maxWidth: 345 }}>
                        <CardMedia
                          component="img"
                          height="140"
                          image={config.API_HOST+"/uploads/"+image}
                          alt={image}
                        />
                        <CardActions>
                          <Button size="small" onClick={() => window.location.href=config.API_HOST+"/uploads/"+image}>Voir</Button>
                          <Button size="small" color="success" onClick={() => {navigator.clipboard.writeText(config.API_HOST+"/uploads/"+image); alert("Lien copié");}}>Copier le lien</Button>
                          <Button size="small" color="error" onClick={() => {
                            if (window.confirm('Êtes-vous sûr de vouloir supprimer cette image ?')) {
                              fetcherSync(config.API_HOST+"/images/"+image, "DELETE");
                              window.location.reload();
                            }
                          }}>Supprimer</Button>
                        </CardActions>
                      </Card>
                  </Grid>
                )
              })
            }
            </Grid>
            

        </Card>
    </CardContent>
)}


